import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from '@/lib/cn.js';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...rest }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'px-2.5 py-1.5 text-[13px] bg-ink-800 border border-ink-600 rounded-md placeholder:text-ink-400 focus-ring w-full leading-relaxed transition-colors',
        className
      )}
      {...rest}
    />
  )
);
Textarea.displayName = 'Textarea';
